import { useEffect, useState, useRef } from "react"
import { btnOne, tableHeader } from "../utils/style"
import fetchData from "../custom_functions/fetchData";
import { useRecoilState } from "recoil";
import uiConfigAtom from "../atoms/uiConfigAtom";
import Button from "./Button";
import { setLoader } from "./Loader";
import { FaChevronLeft, FaChevronRight, FaFilter, FaSearch, FaTimes } from "react-icons/fa";

function Table({ tableData, url, options, pagination, clickHandler, btnTitle, rowClickHandler, noFilter, noButton, excludeFilter, reloadTable, setViewData = null, isMultiSelect = false, selectedRows = [], setSelectedRows = null, multiSelectedKeyPair = null }) {

    {/* If isMultiSelect : true and you want some records already checked then pass multiSelectedKeyPair (ex: { key: "status", value: "Invoiced" }) as params
      to get date componant for filter pass {isDateFilter: true}*/ }

    const [data, setData] = useState([]);
    const [isNextPage, setIsNextPage] = useState(false);
    const [page, setPage] = useState(1);
    const [uiConfig] = useRecoilState(uiConfigAtom)
    const [filterData, setFilterData] = useState({})
    const [active, setActive] = useState('')
    const excludeFilters = excludeFilter || []
    const tableRef = useRef(null);

    const toggleFilter = (header) => {
        setActive(prevState => prevState === header ? '' : header);
    };

    useEffect(() => {
        getData(filterData)
    }, [tableData ? tableData : page, reloadTable])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tableRef.current && !tableRef.current.contains(event.target)) {
                setActive('');
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => { document.removeEventListener('mousedown', handleClickOutside); };
    }, []);

    function togglePage(type) {
        if (type === 'prev' && page > 1) {
            setPage(page - 1)
        }

        if (type === 'next') {
            setPage(page + 1)
        }
    }

    async function getData(filterData) {
        if (!tableData) {
            setLoader(true)
            let reqUrl = url + '?';
            if (pagination) {
                reqUrl = reqUrl + `page=${page}&`
            }
            if (Object.keys(filterData).length > 0) {
                for (let i in filterData) {
                    reqUrl += i + '=' + filterData[i] + '&'
                }
            }
            fetchData(reqUrl, (err) => { console.log(err); setLoader(false) }, (data) => { setData(data.data); setIsNextPage(data.isNextPage || false); setLoader(false) })
        } else {
            setData(tableData)
        }
    }

    function updateFilterData(e) {
        const { name, value } = e.target;
        const data = { ...filterData };
        if (value === '') {
            delete data[name]
        } else {
            data[name] = value;
        }
        setFilterData(data)
    }

    function resetField(field) {
        const data = { ...filterData }
        delete data[field]
        setFilterData(data)
        getData(data)
    }

    const headerStyle = {
        backgroundColor: uiConfig?.table?.headerColor?.hex || '#f8fafc',
        color: uiConfig?.table?.fontColor?.hex || '#1e293b'
    }

    return (
        <div className="w-full bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            {/* Header Section */}
            {!noButton && (
                <div className="flex justify-between items-center p-6 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-white">
                    <div className="flex items-center space-x-3">
                        <div className="w-2 h-8 bg-gradient-to-b from-blue-500 to-purple-600 rounded-full"></div>
                        <h2 className="text-xl font-semibold text-gray-800">Data Table</h2>
                        {data.length > 0 && (
                            <span className="px-3 py-1 bg-blue-50 text-blue-600 text-sm font-medium rounded-full">
                                {data.length} items
                            </span>
                        )}
                    </div>
                    <Button
                        className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white px-6 py-3 rounded-lg font-medium transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl"
                        name={`+ Add ${btnTitle}`}
                        clickHandler={() => clickHandler()}
                    />
                </div>
            )}

            {/* Table Container */}
            <div className="overflow-x-auto">
                <table ref={tableRef} className="w-full">
                    <thead>
                        <tr className="bg-gradient-to-r from-gray-50 to-gray-100">
                            {isMultiSelect && (
                                <th className="px-6 py-4 text-left">
                                    <div className="flex items-center justify-center">
                                        <div className="w-4 h-4 border-2 border-gray-300 rounded-sm bg-white"></div>
                                    </div>
                                </th>
                            )}
                            {options.map((opt, ind) => (
                                <th
                                    key={ind}
                                    className="px-6 py-4 text-left font-semibold text-gray-700 tracking-wide"
                                    style={{ ...headerStyle, width: opt.width ? opt.width : 'auto' }}
                                >
                                    <div className="relative flex items-center justify-between group">
                                        <span className="text-sm font-medium text-gray-700">{opt.header}</span>

                                        {!noFilter && !excludeFilters.includes(opt.header) && (
                                            <div className="flex items-center space-x-2">
                                                <button
                                                    onClick={() => toggleFilter(opt.header)}
                                                    className="p-1.5 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-md transition-all duration-200"
                                                >
                                                    <FaFilter size={12} />
                                                </button>
                                                {filterData[opt.filterKey || opt.key] && (
                                                    <button
                                                        onClick={() => resetField(opt.filterKey || opt.key)}
                                                        className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-md transition-all duration-200"
                                                    >
                                                        <FaTimes size={12} />
                                                    </button>
                                                )}
                                            </div>
                                        )}

                                        {/* Filter Dropdown */}
                                        {!noFilter && opt.header === active && (
                                            <div className="absolute top-12 left-0 z-50 bg-white rounded-lg shadow-xl border border-gray-200 p-4 min-w-64 animate-in slide-in-from-top-2 duration-200">
                                                <div className="space-y-3">
                                                    <div className="flex items-center space-x-2">
                                                        <FaSearch className="text-gray-400" size={14} />
                                                        <input
                                                            type={(opt.key === "date" || opt.isDateFilter === true) ? "date" : "text"}
                                                            name={opt.filterKey || opt.key}
                                                            value={filterData[opt.filterKey || opt.key] || ''}
                                                            className="flex-1 px-3 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            placeholder={`Filter ${opt.header.toLowerCase()}...`}
                                                            onChange={updateFilterData}
                                                        />
                                                    </div>
                                                    <div className="flex space-x-2">
                                                        <button
                                                            className="flex-1 px-4 py-2 bg-blue-500 text-white text-xs font-medium rounded-md hover:bg-blue-600 transition-colors duration-200"
                                                            onClick={() => { setActive(''); getData(filterData) }}
                                                        >
                                                            Apply Filter
                                                        </button>
                                                        <button
                                                            className="px-4 py-2 text-gray-600 text-xs font-medium border border-gray-200 rounded-md hover:bg-gray-50 transition-colors duration-200"
                                                            onClick={() => setActive('')}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {data?.length > 0 ? (
                            data.map((dt, ind) => {
                                const isChecked = selectedRows?.some(row => row.id === dt.id);

                                return (
                                    <tr
                                        key={ind}
                                        className="hover:bg-gray-50 transition-colors duration-150 cursor-pointer group"
                                        onClick={(e) => {
                                            rowClickHandler?.(ind);
                                            setViewData?.(dt);
                                        }}
                                    >
                                        {isMultiSelect && (
                                            <td className="px-6 py-4">
                                                <div className="flex items-center justify-center">
                                                        {Array.isArray(multiSelectedKeyPair) && multiSelectedKeyPair.some(pair => dt[pair.key] === pair.value) ? (
                                                            <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                                                                <span className="text-green-600 text-xs font-bold">✓</span>
                                                            </div>
                                                        ) : (
                                                            <input
                                                                type="checkbox"
                                                                checked={isChecked}
                                                                onChange={(e) => {
                                                                    let updatedRows = [];
                                                                    if (e.target.checked) {
                                                                        updatedRows = [...selectedRows, dt];
                                                                    } else {
                                                                        updatedRows = selectedRows.filter(row => row.id !== dt.id);
                                                                    }
                                                                    setSelectedRows?.(updatedRows);
                                                                }}
                                                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                                                            />
                                                        )}
                                                </div>
                                            </td>
                                        )}
                                        {options.map((opt, indx) => (
                                            <td key={indx} className="px-6 py-4">
                                                <div className="text-sm text-gray-900 group-hover:text-gray-700 transition-colors duration-150">
                                                    {opt.render ? opt.render(dt, ind) : dt[opt.key]}
                                                </div>
                                            </td>
                                        ))}
                                    </tr>
                                )
                            })
                        ) : (
                            <tr>
                                <td className="px-6 py-12 text-center" colSpan={options.length + (isMultiSelect ? 1 : 0)}>
                                    <div className="flex flex-col items-center space-y-3">
                                        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
                                            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="text-gray-500 font-medium">No data found</p>
                                            <p className="text-gray-400 text-sm">Try adjusting your filters or add new data</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            {pagination && (
                <div className="flex items-center justify-between px-6 py-4 bg-gray-50 border-t border-gray-100">
                    <div className="text-sm text-gray-600">
                        Page {page} of results
                    </div>
                    <div className="flex items-center space-x-2">
                        <button
                            type="button"
                            className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                            onClick={() => togglePage('prev')}
                            disabled={page === 1}
                        >
                            <FaChevronLeft size={12} />
                            <span>Previous</span>
                        </button>

                        <div className="flex items-center space-x-1">
                            <span className="px-3 py-2 text-sm font-medium text-white bg-gradient-to-r from-blue-500 to-purple-600 rounded-md shadow-sm">
                                {page}
                            </span>
                        </div>

                        <button
                            type="button"
                            className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                            onClick={() => togglePage('next')}
                            disabled={!isNextPage}
                        >
                            <span>Next</span>
                            <FaChevronRight size={12} />
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Table;